export const gtmDataLayer = (): unknown[] => {
	if (typeof window === "undefined") return [];
	window.dataLayer = window.dataLayer || [];
	return window.dataLayer;
};
